module.exports = __webpack_public_path__ + "img/scenery-5.21324394.png";